import React, { FC } from 'react';


interface ButtonBack {
  title: string;
  url?: string;
  onClick?: any;
}

const ButtonCTA: FC<ButtonBack> = ({ title, url, onClick }): JSX.Element => {
  return (
    <div className='default-button-cta'>
      <a
        href={url}
        target='_blank'
        rel="noopener noreferrer"
        onClick={onClick}
      >
        {/*<div className="button-cta-icon">*/}
        {/*  <img alt="" src={`${process.env.PUBLIC_URL}/assets/images/next.svg`}/>*/}
        {/*</div>*/}
        <div className="button-cta-title">{title}</div>
      </a>
    </div>
  );
};

export default ButtonCTA;
